import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledIcon,
  StyledChild,
  StyledMobilePMWrapper,
  StyledText,
  StyledHorizontalScrollWrapper,
} from './styles'
import { ContentUnWrapper } from '../../atoms/contentWrapper'
import { getPathNavigation } from '../../../utils/getWebsiteUrl'

const MobilePMCarousel = (props) => {
  const { slides } = props
  const { length } = slides
  return (
    <ContentUnWrapper addPaddingToChild>
      <StyledHorizontalScrollWrapper>
        <StyledMobilePMWrapper length={length}>
          {slides.map((slide, i) => (
            <StyledChild key={`pm-child-${i}`} to={getPathNavigation(slide.link)} name="">
              <StyledIcon
                width={285}
                height={115}
                src={slide.icon?.image.url}
                alt=""
                loading={i < 4 ? 'eager' : 'lazy'}
              />
              <StyledText noSpacing>{slide.text}</StyledText>
            </StyledChild>
          ))}
        </StyledMobilePMWrapper>
      </StyledHorizontalScrollWrapper>
    </ContentUnWrapper>
  )
}

MobilePMCarousel.defaultProps = {
  slides: [],
}

MobilePMCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
      icon: PropTypes.shape({
        image: PropTypes.shape({
          url: PropTypes.string,
          alt: PropTypes.string,
        }),
      }),
    })
  ).isRequired,
}

export { MobilePMCarousel }
